module.exports = __webpack_public_path__ + "img/ticket_ex2.c5be8990.svg";